import {
  FieldMappingFileListField,
  FieldMappingFileListFieldProps,
} from '@components/field-mapping-file-field';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormFieldMappingFileListFieldProps<T = unknown> = FormFieldProps<
  FieldMappingFileListFieldProps,
  T
>;

export function FormFieldMappingFileListField<T>(props: FormFieldMappingFileListFieldProps<T>) {
  const formFieldProps = useFormField({ ...props, valueType: 'field-mapping-list' });

  return <FieldMappingFileListField {...props} {...formFieldProps} />;
}
